import type { SVGProps } from 'react';

export type IconName =
  | 'compass'
  | 'gauge'
  | 'wand'
  | 'spark'
  | 'alert'
  | 'book'
  | 'cog'
  | 'chev'
  | 'check'
  | 'play'
  | 'pause'
  | 'reset'
  | 'x'
  | 'drop'
  | 'flame';

type IconProps = {
  name: IconName;
  size?: number;
  color?: string;
};

export function Icon({ name, size = 16, color = 'currentColor' }: IconProps) {
  const svg: SVGProps<SVGSVGElement> = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: color,
    strokeWidth: 1.7,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  };

  switch (name) {
    case 'compass':
      return (
        <svg {...svg}>
          <circle cx="12" cy="12" r="9" />
          <path d="m15 9-3 7-3-7 6 0z" fill={color} stroke="none" />
        </svg>
      );
    case 'gauge':
      return (
        <svg {...svg}>
          <path d="M4 16a8 8 0 1 1 16 0" />
          <path d="M12 16l4-5" />
        </svg>
      );
    case 'wand':
      return (
        <svg {...svg}>
          <path d="M4 20 20 4" />
          <path d="M14 4h4v4" />
          <path d="M10 16l4-4" />
        </svg>
      );
    case 'spark':
      return (
        <svg {...svg}>
          <path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M6 18l2.5-2.5M15.5 8.5 18 6" />
        </svg>
      );
    case 'alert':
      return (
        <svg {...svg}>
          <path d="M12 3 2 20h20L12 3z" />
          <path d="M12 10v4M12 17.5v.5" />
        </svg>
      );
    case 'book':
      return (
        <svg {...svg}>
          <path d="M4 5a2 2 0 0 1 2-2h12v16H6a2 2 0 0 0-2 2V5z" />
          <path d="M8 7h8M8 11h8" />
        </svg>
      );
    case 'cog':
      return (
        <svg {...svg}>
          <circle cx="12" cy="12" r="3" />
          <path d="M12 2v2M12 20v2M4 12H2M22 12h-2M6 6 4.5 4.5M19.5 19.5 18 18M6 18l-1.5 1.5M19.5 4.5 18 6" />
        </svg>
      );
    case 'chev':
      return (
        <svg {...svg}>
          <path d="m9 6 6 6-6 6" />
        </svg>
      );
    case 'check':
      return (
        <svg {...svg}>
          <path d="m5 13 4 4 10-10" />
        </svg>
      );
    case 'play':
      return (
        <svg {...svg}>
          <path d="M7 5v14l11-7L7 5z" fill={color} />
        </svg>
      );
    case 'pause':
      return (
        <svg {...svg}>
          <rect x="6" y="5" width="4" height="14" rx="1" fill={color} stroke="none" />
          <rect x="14" y="5" width="4" height="14" rx="1" fill={color} stroke="none" />
        </svg>
      );
    case 'reset':
      return (
        <svg {...svg}>
          <path d="M4 4v6h6" />
          <path d="M4 10a9 9 0 1 1 2.5 6" />
        </svg>
      );
    case 'x':
      return (
        <svg {...svg}>
          <path d="M6 6l12 12M18 6 6 18" />
        </svg>
      );
    case 'drop':
      return (
        <svg {...svg}>
          <path d="M12 3c-4 5-6 8-6 11a6 6 0 0 0 12 0c0-3-2-6-6-11z" />
        </svg>
      );
    case 'flame':
      return (
        <svg {...svg}>
          <path d="M12 3c1 3 5 5 5 10a5 5 0 0 1-10 0c0-2 1-3 2-4-1 2 0 4 2 4 0-3 0-6 1-10z" />
        </svg>
      );
  }
}
